import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverHosQuickInfo extends Layout {
    panelQuickInfo: Panel;
    sourceDriverInfo: DataSource;
    textboxDriverAvlHrs: Textbox;
    textboxDriverAvlHrsToday: Textbox;
    textboxDriverAvlHrsTomorrow: Textbox;
    textboxDriverOnDutyAvlHrs: Textbox;
    textboxDutyStatus: Textbox;
    textboxLastUpdated: Textbox;
    textboxName: Textbox;
}
